/* global api */
import { LogEntry } from '../../models'

const state = {
  logLimit: 200,
  diagnosticsSent: false,
  diagnosticSubmissionSuccessful: false,
  diagnosticSubmissionInProgress: false,
  diagnostics: [],
  logs: []
}
const mutations = {
  commitDiagnosticsSent (state, meta) {
    state.diagnosticsSent = meta
  },
  commitDiagnosticSubmissionSuccessful (state, meta) {
    state.diagnosticSubmissionSuccessful = meta
  },
  commitDiagnosticSubmissionInProgress (state, meta) {
    state.diagnosticSubmissionInProgress = meta
  },
  commitDiagnostics (state, meta) {
    state.diagnostics = meta
  },
  commitLog (state, meta) {
    state.logs.push(meta)
    if (state.logs.length > state.logLimit) {
      state.logs.shift()
    }
  },
  commitClearLogs (state) {
    state.logs = []
  }
}
const actions = {
  async submitDiagnostics ({ commit, getters, rootGetters, rootState }) {
    try {
      commit('commitDiagnosticSubmissionInProgress', true)
      const env = {}
      if (navigator.appCodeName !== undefined) {
        env.appCodeName = navigator.appCodeName
      }
      if (navigator.appName !== undefined) {
        env.appName = navigator.appName
      }
      if (navigator.appVersion !== undefined) {
        env.appVersion = navigator.appVersion
      }
      if (navigator.connection !== undefined && navigator.connection.effectiveType !== undefined) {
        env.connection = navigator.connection.effectiveType
      }
      if (navigator.platform !== undefined) {
        env.platform = navigator.platform
      }
      if (navigator.product !== undefined) {
        env.product = navigator.product
      }
      if (navigator.productSub !== undefined) {
        env.productSub = navigator.productSub
      }
      if (navigator.userAgent !== undefined) {
        env.userAgent = navigator.userAgent
      }
      if (navigator.vendor !== undefined) {
        env.vendor = navigator.vendor
      }
      env.pwa = window.matchMedia('(display-mode: standalone)').matches

      const user = rootGetters['authentication/user']
      const diagnostics = {}
      diagnostics.branch_id = user.primaryBranchId
      diagnostics.buildNumber = process.env.VUE_APP_COMMIT_HASH
      diagnostics.buildDate = process.env.VUE_APP_COMMIT_DATE
      diagnostics.env = env
      diagnostics.user = user
      diagnostics.forms = rootGetters['offline/forms']
      diagnostics.logs = []
      getters.logs.forEach((value) => {
        diagnostics.logs.push({ ...value })
      })

      const method = 'post'
      const result = await api.call(method, rootState.apiUrl + 'addDiagnostic', diagnostics)
      commit('commitDiagnosticSubmissionInProgress', false)
      commit('commitDiagnosticsSent', true)
      commit('commitDiagnosticSubmissionSuccessful', result.success)
    } catch (error) {
      const logEntry = new LogEntry('support.js submitDiagnostics error', error)
      commit('commitLog', logEntry)

      console.log('submitDiagnostics error')
      console.log(error)
    }
  },
  setDiagnosticsSent ({ commit }, meta) {
    commit('commitDiagnosticsSent', meta)
  },
  setDiagnosticSubmissionSuccessful ({ commit }, meta) {
    commit('commitDiagnosticSubmissionSuccessful', meta)
  },
  async getDiagnostics ({ commit, rootState }) {
    try {
      const result = await api.get(rootState.apiUrl + 'getDiagnostics')
      commit('commitDiagnostics', result.message)
    } catch (error) {
      const logEntry = new LogEntry('support.js getDiagnostics error', error)
      commit('commitLog', logEntry)

      console.log('getDiagnostics error')
      console.log(error)
    }
  },
  async setDiagnosticSeen ({ commit, rootState }, meta) {
    try {
      const diagnostic = {}
      diagnostic.id = meta
      const method = 'post'
      await api.call(method, rootState.apiUrl + 'setDiagnosticSeen', diagnostic)
    } catch (error) {
      const logEntry = new LogEntry('support.js setDiagnosticSeen error', error)
      commit('commitLog', logEntry)

      console.log('setDiagnosticSeen error')
      console.log(error)
    }
  },
  addLog ({ commit }, meta) {
    commit('commitLog', meta)
  },
  clearLogs ({ commit }) {
    commit('commitClearLogs')
  }
}
const getters = {
  diagnosticsSent: state => state.diagnosticsSent,
  diagnosticSubmissionSuccessful: state => state.diagnosticSubmissionSuccessful,
  diagnosticSubmissionInProgress: state => state.diagnosticSubmissionInProgress,
  diagnostics: state => state.diagnostics,
  getDiagnostic: (state) => async (id) => {
    if (state.diagnostics !== undefined) {
      return await state.diagnostics.find(diagnostic => parseInt(diagnostic.id) === parseInt(id))
    }
    return {}
  },
  logs: state => state.logs
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
